/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_CargoInputs */

const en_cargos_cargo = /** @type {(inputs: Cargos_CargoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo`)
};

const es_cargos_cargo = /** @type {(inputs: Cargos_CargoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

/**
* | output |
* | --- |
* | "Cargo" |
*
* @param {Cargos_CargoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_cargo = /** @type {((inputs?: Cargos_CargoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_CargoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_cargo(inputs)
	return es_cargos_cargo(inputs)
});